import { createBrandPayload } from "../../../types/brand.types";

export const IbrandState: createBrandPayload = {
  name: "",
  brand_img: "",
};
